import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://bankably.co/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bankably_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('bankably_access_token');
      localStorage.removeItem('bankably_refresh_token');
      localStorage.removeItem('bankably_user');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export interface ApiUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isAdmin: boolean;
}
